import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const BookOpenText: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z' }],
    ['path', { d: 'M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z' }],
    ['path', { d: 'M6 8h2' }],
    ['path', { d: 'M6 12h2' }],
    ['path', { d: 'M16 8h2' }],
    ['path', { d: 'M16 12h2' }],
  ],
];

export default BookOpenText;
